import React from 'react';
import { NavLink } from 'react-router-dom';

const NavBar = (props) => (
  <div>
    <header className="header">
      <h1 className="logo"><NavLink to="/">{props.title}</NavLink></h1>
      <ul className="main-nav">
        <li><NavLink to="/">Home</NavLink></li>
        <li><NavLink activeClassName="activeNavLink" to="/projects">Projects</NavLink></li>
        <li><NavLink activeClassName="activeNavLink" to="/about">About Me</NavLink></li>
        <li><NavLink activeClassName="activeNavLink" to="/contact">Contact</NavLink></li>
        <li><NavLink activeClassName="activeNavLink" to="/resume">Resume</NavLink></li>
      </ul>
    </header>
  </div>
);


export default NavBar;


// WEBPACK FOOTER //
// ./src/components/NavBar/index.js